<template>
  <div class="map_content">
    <!-- <WorldMap /> -->
    <div v-show="!acquiesce" class="information_collection">
      <span>信息收集完成度:</span>
      <span class="high">
        <span></span>
        <span>高</span>
      </span>
      <span class="in_the">
        <span></span>
        <span>中</span>
      </span>
    </div>
    <div class="echarts" ref="Echarts" />
  </div>
</template>

<script>
import World from 'echarts/map/world.json';
export default {
  props: {
    acquiesce: { type: Boolean, default: false },
    data: { type: Array, default: () => [] },
  },
  data() {
    return {
      echarts: null,
      options: {},
      countrydata: []
    }
  },
  created() {
    window.addEventListener('resize', this.updateMap);
  },
  watch: {
    data: {
      deep: true,
      handler: function () {
        this.setCountrydata();
      }
    },
    acquiesce: function () {
      this.setOptions();
    }
  },
  mounted() {
    this.getFontSize();
    this.initEcharts();
  },
  methods: {
    setCountrydata() {
      let list = [];
      this.data.forEach(item => {
        if (item.mapName.indexOf("Russia") > -1) item.mapName = "Russia";
        list.push({ "name": item.mapName, "value": item.id, "itemStyle": { normal: { color: item.worldMapColor } }, "url": item.linkAddress });
      });
      this.countrydata = list;
      this.setOptions();
    },
    initEcharts() {
      this.$ECharts.registerMap("world", World);
      this.echarts = this.$ECharts.init(this.$refs.Echarts);
      this.setOptions();
      this.echarts.on('click', (echartsData = null) => {
        if (echartsData && echartsData.data) {
          let key = this.acquiesce ? "home_map_search" : "home_map_skip";
          this.$FN.limitsTips({ list: [key] }).then(res => {
            if (res) {
              if (echartsData.data.url) return window.open(echartsData.data.url);
              this.$router.$push({ path: "standard", query: { mode: "standardSearch_system", keywords: echartsData.data.name } })
              // let url = `${this.$FN.iframeUrl}/page/standard_search_old?keywords=${echartsData.data.name}`;
              // this.$router.$push({ path: "/container", query: { url } })
            }
          });
        };
      })
    },
    updateMap() {
      this.getFontSize();
      this.setOptions();
      this.echarts.resize();
    },
    getFontSize() {
      this.fontSize = this.$FN.getFontSize(this.$refs.Echarts);
    },
    getSplatteringOption() {
      const splatteringOption = {
        title: {
          left: 'center',
          top: 'top'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b}'
        },
        dataRange: {
          show: false,
          x: 'right',
          y: 'center',
          selectedMode: true,
          calculable: false,
          splitList: [
            { start: 0, end: 200, color: '#2d6ec0' },
          ],
          splitNumber: 1
        },
        geo: {
          map: "world",
          itemStyle: {					// 定义样式
            normal: {					// 普通状态下的样式
              areaColor: '#e0e0e0',
              borderColor: '#fff'
            }
          },
          silent: true,
          roam: false
        },

        series: [{
          name: 'pot',
          type: 'effectScatter',
          map: 'world',
          coordinateSystem: "geo",
          showEffectOn: 'render',
          slient: true,
          label: {
            show: true,
            position: "right",
            distance: 5,
            formatter: '{b}',
            fontSize: this.fontSize * 2
          },
          itemStyle: {					// 定义样式
            color: "#2d6ec0",
            normal: {					// 普通状态下的样式
              areaColor: '#2d6ec0'
            }
          },
          symbolSize: this.fontSize,
          rippleEffect: {
            scale: 6,
            brushType: "stroke",
            period: 5
          },
          hoverAnimation: true,
          data: [
            { name: 'ISO', value: [6.066667, 47.233333, 1] },
            { name: 'IEC', value: [6.126579, 43.2050282, 10] },
            { name: 'AWS', value: [-78.2562233, 25.7833333, 10] },
            { name: 'IEEE', value: [-73.9833734, 40.7465582, 10] },
            { name: 'ASME', value: [-71.9846823, 44.7462972, 10] },
            { name: 'ASTM', value: [-76.2581152, 37.0024137, 10] },
            { name: 'BIS', value: [77.1199742, 28.4941485, 10] },
            { name: 'EN', value: [4.3053508, 50.8549541, 10] },
            { name: 'API', value: [-123.1246277, 47.2511091, 10] },
            { name: 'ACI', value: [-90.4008166, 44.4553997, 10] },
            { name: 'GB', value: [118.1172815, 43.9385466, 10] },
            { name: 'DL', value: [115.1172815, 39.9385466, 10] },
            { name: 'NB', value: [117.1172815, 35.9385466, 10] },
          ]
        }],
      };
      return splatteringOption;
    },
    getColorOption() {
      const colorOption = {
        title: {
          left: 'center',
          top: 'top'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b}'
        },
        visualMap: {
          min: 800,
          max: 50000,
          text: ['High', 'Low'],
          realtime: false,
          calculable: true,
          inRange: {
            color: ['lightskyblue', 'yellow', 'orangered']
          }
        },
        dataRange: {
          show: false,
          x: 'right',
          y: 'bottom',
          selectedMode: true,
          text: ['信息收集完成度-中', '信息收集完成度-高'], // 文本，默认为数值文本
          calculable: false,
          splitList: [
            { start: 22, end: 22, color: '#2d6ec0' },
            { start: 39, end: 39, color: '#2d6ec0' },
            { start: 41, end: 41, color: '#2d6ec0' },
            { start: 50, end: 50, color: '#2d6ec0' },
            { start: 54, end: 54, color: '#2d6ec0' },
            { start: 113, end: 114, color: '#2d6ec0' },
            { start: 1, end: 21, color: '#87cefa' },
            { start: 23, end: 38, color: '#87cefa' },
            { start: 40, end: 40, color: '#87cefa' },
            { start: 42, end: 49, color: '#87cefa' },
            { start: 51, end: 53, color: '#87cefa' },
            { start: 55, end: 112, color: '#87cefa' },
            { start: 115, end: 120, color: '#87cefa' }
          ],
          splitNumber: 2
        },
        series: [{
          name: 'World Population (2010)',
          type: 'map',
          map: 'world',
          roam: false,
          itemStyle: {
            normal: {
              areaColor: "#eee",
              borderColor: "#fff"
            },
            emphasis: {
              //选中时的颜色
              areaColor: "#23559a",
              label: { show: false }
            }
          },
          label: {
            normal: {
              show: false
            },
            emphasis: {
              show: false
            }
          },
          data: this.countrydata
        }]
      };
      return colorOption;
    },
    setOptions() {
      this.options = this[this.acquiesce ? 'getSplatteringOption' : 'getColorOption']();
      this.echarts.setOption(this.options);
    },
  }
}
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>